import { FileTypes } from 'taboola-ultimate-ui';

export const ONLY_IMAGE_FILES = { [FileTypes.IMAGE]: [] };
export const ONLY_IMAGE_FILES_NO_GIF = {
    'image/jpeg': [],
    'image/png': [],
};
export const ONLY_MOTION_FILES = { [FileTypes.VIDEO]: [], [FileTypes.IMAGE]: ['.gif'] };
export const ALL_MEDIA_FILES = { ...ONLY_MOTION_FILES, ...ONLY_IMAGE_FILES };
export const ALL_HOSTED_MEDIA_FILES = {
    [FileTypes.ARCHIVE]: ['.zip'],
    [FileTypes.IMAGE]: ['.jpg', '.jpeg', '.png', '.gif'],
    [FileTypes.VIDEO]: ['.mp4', '.mpg', '.flv', '.webm'],
};
